import { HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { ReponseFiltre } from './reponses/reponse-filter';  
import { RapportSST } from "../entites/rapport-sst";
import { LazyLoadEvent, MessageService } from "primeng/api";
import { BaseService } from "./base.service";
import { Emplacement } from "../entites/emplacement";
import { EmployeEntite } from "../entites/employe";

@Injectable({ providedIn: 'root' })
export class RapportSstService extends BaseService {

  private obtenirListeUrl = environment.apiBaseUrl + 'rapportsst';

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router,
    public messageService: MessageService
  ) { 
    super(messageService, router);
  }

  public Obtenir(event: LazyLoadEvent): Observable<ReponseFiltre<RapportSST>> {
    return this.http.get<ReponseFiltre<RapportSST>>(this.obtenirListeUrl, { params: this.GenerateFilterParams(event) });
  }

  public ObtenirRapportSst(id: number): Observable<RapportSST> {
    return this.http.get<RapportSST>(`${environment.apiBaseUrl}rapportsst/${id}`);
  }

  public ObtenirPourMois(dateDebut: Date, dateFin: Date, emplacements: Emplacement[]): Observable<RapportSST[]> {
    var params = new HttpParams();
    params = params.append('dateDebut', dateDebut.toISOString());
    params = params.append('dateFin', dateFin.toISOString());
    if (emplacements.length > 0) {
      emplacements.forEach(e => params = params.append('emplacementIds', e.emplacementId.toString()));
    }
    return this.http.get<RapportSST[]>(`${this.obtenirListeUrl}/mois`, { params });
  }

  public Ajouter(rapportSST: RapportSST, copierValeurs: boolean = true): Observable<RapportSST> {
    var params = new HttpParams();
    params = params.append('copierValeurs', copierValeurs.toString());
    return this.http.post<RapportSST>(this.obtenirListeUrl, rapportSST, { headers: this.httpOptions.headers, params });
  }

  public Modifier(rapportSST: RapportSST): Observable<void> {
    return this.http.put<void>(`${environment.apiBaseUrl}rapportsst`, rapportSST).pipe(
      catchError(error => {
        this.handleError(error);
        return throwError(() => error);
      })
    );
  }

  ObtenirDestinatairesParDefaut(rapportSstId: number): Observable<EmployeEntite[]> {
    return this.http.get<EmployeEntite[]>(`${environment.apiBaseUrl}rapportsst/${rapportSstId}/destinataires`);
  }

  EnvoyerEtFermerRapportSst(rapportSstId: number, destinataires: string[]): Observable<void> {
    return this.http.post<void>(`${environment.apiBaseUrl}rapportsst/${rapportSstId}/envoyer`, { destinataires });
  }
}

